import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { connectRoutes } from 'redux-first-router';
import reduxThunk from 'fsa-redux-thunk';

import { isServer } from '../lib/utils';

import {
  hydrateSessionState,
  setProspectUser,
  setSessionUser,
} from './session/actions';
import { saveReturnPath } from './location/actions';
import { selectProspectUser, selectUser } from './session/selectors';
import routerOptions from './routerOptions';
import reducers from './reducers';
import actionCreators from './actions';

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        actionCreators,
      })
    : compose;

export function configureStore(preLoadedState, options) {
  const { reducer, middleware, enhancer, thunk } = connectRoutes(
    options.routesMap,
    {
      ...routerOptions,
      ...options.routerOptions,
    }
  );

  const rootReducer = combineReducers({ ...reducers, location: reducer });
  const middlewares = applyMiddleware(reduxThunk, middleware);
  const enhancers = composeEnhancers(enhancer, middlewares);
  const store = createStore(rootReducer, preLoadedState, enhancers);

  if (!isServer) {
    compose(store.dispatch, hydrateSessionState)();

    // This exists to fire the various tracking events to identify the user. The
    // user and prospect user should already exist in the store.
    // TODO: [AP] I am not sure the original author's intention here, but it
    // seems like they are selecting the user from the store and re-setting it
    // to the store as a way to trigger analytics, which seems like the wrong
    // thing to do given these setters now perform other tasks.
    compose(store.dispatch, setSessionUser, selectUser, store.getState)();
    compose(
      store.dispatch,
      setProspectUser,
      selectProspectUser,
      store.getState
    )();

    // save returnPath for authentication re-redirects
    compose(store.dispatch, saveReturnPath)();
  }

  if (module.hot && process.env.NODE_ENV === 'development') {
    module.hot.accept('./reducers', async () => {
      const { default: reducers } = await import('./reducers');
      const rootReducer = combineReducers({ ...reducers, location: reducer });
      store.replaceReducer(rootReducer);
    });
  }

  return { store, thunk };
}
